import { useWeb3State } from "@/web3/context";
import { useMutation } from "@tanstack/react-query";
import { useRef, useCallback } from "react";

const useEIP712Signature = ({ onError }: { onError: () => void }) => {
  const { currentAddress: signer, web3 } = useWeb3State();

  // TODO -> Solve EIP712 spamming without refs
  const canSendAsync = useRef(true);

  const signTypedData = useCallback(
    async (data: any) => {
      canSendAsync.current = false;

      return await web3!.provider.send("eth_signTypedData_v4", [signer, data]);
    },
    [web3, signer],
  );

  const { mutateAsync: sendMessageForSign } = useMutation({
    mutationFn: async (typedData: any) => {
      if (!web3 || !canSendAsync.current) return;

      return await signTypedData(typedData);
    },
    onError: () => {
      canSendAsync.current = true;
      onError();
    },
  });

  return sendMessageForSign;
};

export default useEIP712Signature;
